export default __webpack_public_path__ + "img/Bees-Rewards.png";